export default __webpack_public_path__ + "static/media/c006-c.c08753d0.png";